import React from 'react';
import styled from '@emotion/styled';

import NewsCard from '../elements/NewsCard';
import CategoryThumbnail from '../elements/CategoryThumbnail';

import vw from 'styles/utils';
import media from 'styles/media';

// import { getLatestArticle } from 'utils/request';
import latestArticle from 'data/latestArticle';
import mainCategories from 'data/mainCategories';

function News() {
  // const [latestArticle, setLatestArticle] = useState({})

  // useEffect(() => {
  //   async function fetchData() {
  //     const latestArticle = await getLatestArticle();
  //     setLatestArticle(latestArticle.ArticleList)
  //   }
  //   fetchData();
  // }, [])

  return (
    <Root>
      <NewsRow>
        <ColumnLeft>
          <NewsCard
            imgUrl={latestArticle.ArticleList[0].image}
            title={latestArticle.ArticleList[0].title}
            author={latestArticle.ArticleList[0].author}
            url={latestArticle.ArticleList[0].url}
          />
        </ColumnLeft>
        <ColumnRight>
          <NewsCard
            imgUrl={latestArticle.ArticleList[1].image}
            title={latestArticle.ArticleList[1].title}
            author={latestArticle.ArticleList[1].author}
            url={latestArticle.ArticleList[1].url}
          />
          <NewsCard
            imgUrl={latestArticle.ArticleList[2].image}
            title={latestArticle.ArticleList[2].title}
            author={latestArticle.ArticleList[2].author}
            url={latestArticle.ArticleList[2].url}
          />
        </ColumnRight>
      </NewsRow>
      <CategoryButtonRow>
        {
          mainCategories.map((category) => (
            <CategoryThumbnail 
              title={category.title} 
              // subtitle1={category.subtitle1}
              href1={category.href1} 
              // subtitle2={category.subtitle2}
              // href2={category.href2}
              key={category.title}
            />
          ))
        }
      </CategoryButtonRow>
    </Root>
  )
}

const Root = styled.section`
  ${vw('margin-bottom', 20, 30)}
`;

const NewsRow = styled.div`
  width: 100%;
  display: flex;

  ${vw('height', 185, 370)}
  ${vw('margin-bottom', 15, 30)}
`;

const ColumnLeft = styled.div`
  width: 52%;

  @media ${media.tablet} {
    width: 60%;
  }

  @media ${media.desktop} {
    width: 65%;
  }
`;

const ColumnRight = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;

  @media ${media.tablet} {
    width: 40%;
  }

  @media ${media.desktop} {
    width: 35%;
  }
`;

const CategoryButtonRow = styled.div`
  display: grid;
  grid-template-columns: auto auto;

  @media ${media.tablet} {
    grid-template-columns: auto auto auto auto;
  }
  
  ${vw('height', 240, 120)}
  ${vw('grid-column-gap', 10)}
  ${vw('grid-row-gap', 10, 0)}
`;

export default News
